import { useNavigate, Link } from 'react-router-dom'
import { AlertTriangle, ShieldOff, FileQuestion, RefreshCw, Home } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="text-center max-w-sm">
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mx-auto mb-6">
          <FileQuestion className="w-8 h-8 text-muted-foreground" />
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-2">صفحه یافت نشد</h1>
        <p className="text-sm text-muted-foreground mb-6">
          آدرسی که وارد کردید وجود ندارد یا منتقل شده است.
        </p>
        <Link to="/projects">
          <Button className="gap-1.5">
            <Home className="w-4 h-4" />
            بازگشت به پروژه‌ها
          </Button>
        </Link>
      </div>
    </div>
  )
}

export function PermissionDeniedPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="text-center max-w-sm">
        <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-6">
          <ShieldOff className="w-8 h-8 text-destructive" />
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-2">دسترسی ندارید</h1>
        <p className="text-sm text-muted-foreground mb-6">
          شما مجوز دسترسی به این بخش را ندارید. اگر فکر می‌کنید این اشتباه است با مدیر پروژه تماس بگیرید.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link to="/projects">
            <Button variant="outline" className="gap-1.5">
              <Home className="w-4 h-4" />
              پروژه‌ها
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export function GenericErrorPage({ error, onRetry }: { error?: Error; onRetry?: () => void }) {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="text-center max-w-sm">
        <div className="w-16 h-16 rounded-full bg-yellow-500/10 flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-8 h-8 text-yellow-400" />
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-2">مشکلی پیش آمد</h1>
        <p className="text-sm text-muted-foreground mb-2">
          خطای غیرمنتظره‌ای رخ داد. لطفاً دوباره تلاش کنید.
        </p>
        {error && (
          <p className="text-xs font-mono text-muted-foreground/60 mb-6 break-all">
            {error.message}
          </p>
        )}
        <div className="flex items-center justify-center gap-3">
          {onRetry && (
            <Button onClick={onRetry} className="gap-1.5">
              <RefreshCw className="w-4 h-4" />
              تلاش مجدد
            </Button>
          )}
          <Button variant="outline" onClick={() => navigate(-1)} className="gap-1.5">
            <Home className="w-4 h-4" />
            بازگشت
          </Button>
        </div>
      </div>
    </div>
  )
}
